import { Component, Input, OnInit } from '@angular/core';
import { Product } from 'src/app/models/product.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-production-tracking-endprocess',
  templateUrl: './production-tracking-endprocess.component.html',
  styleUrl: './production-tracking-endprocess.component.less'
})
export class ProductionTrackingEndprocessComponent implements OnInit {
  @Input() product?: Product;

  isDisplayed = false;

  apiUrl:string = environment.API_URL;

  constructor() {}

  ngOnInit(): void {
    this.isDisplayed = !!this.product?.gok || !!this.product?.leftGate;
  }
}
